import { React } from 'mondrian-react';

import { logger } from "utils/logger";
import { setCookie, getCookie } from "utils/cookie";
import useIsTotem from 'hooks/useIsTotem';

import './styles.scss';

const AlertPWA = () => {
  const [prompt, setPrompt] = React.useState(null);
  const [isInstalledPwa, setIsInstalledPwa] = React.useState(false);
  const [isTemporaryPwa, setIsTemporaryPwa] = React.useState(false);

  const isTotem = useIsTotem();

  const openPopupInstallPWA = (promptCurrent) => {
    promptCurrent.prompt();
  }

  const closeAlertWPA = (status) => {
    if(status){
      setIsTemporaryPwa(false)
    } else {
      setCookie("pwa-temporary", true, 1);
      setIsTemporaryPwa(true)
      logger({ name: "ClosePWA" });
    }
  }

  React.useEffect(() => {
    const tempInstalledPwa = Boolean(localStorage.getItem("install-pwa"));
    if(tempInstalledPwa === null || tempInstalledPwa === false){
      setIsInstalledPwa(false);
    } else {
      setIsInstalledPwa(true);
    }
  }, [])

  React.useEffect(() => {
    const tempTemporaryPwa = Boolean(getCookie("pwa-temporary"));
    if(tempTemporaryPwa === null || tempTemporaryPwa === false){
      setIsTemporaryPwa(false);
    } else {
      setIsTemporaryPwa(true);
    }
  }, [])

  React.useEffect(() => {
    window.addEventListener("beforeinstallprompt", (event) => {
      event.preventDefault();
      localStorage.removeItem('install-pwa');
      localStorage.setItem('install-pwa', false);
      setIsInstalledPwa(false);
      setIsTemporaryPwa(false);
      setPrompt(event);
    });
    
    window.addEventListener('appinstalled', (event) => {
      event.preventDefault();
      logger({ name: "InstallPWA" });
      logger({ name: "AbriuPWA" });
      localStorage.setItem('install-pwa', true);
      setCookie("pwa-temporary", true, 1);
      setIsInstalledPwa(true);
    });

    console.log("test >>> ", window.matchMedia('(display-mode: standalone)').matches);

    if (window.matchMedia('(display-mode: standalone)').matches) {
      logger({ name: "AbriuPWA" });
    }
  }, [])

  React.useEffect(() => {
    if(!isTemporaryPwa && !isInstalledPwa){
      const pwa = document.getElementById('wrapperPwa')
      let heightPWA = pwa.offsetHeight;
      document.body.style.marginBottom = `${heightPWA}px`
      document.body.classList.add('bodyMarginBottomPWA')
      window.addEventListener('resize', function(){
        heightPWA = pwa.offsetHeight;
        document.body.style.marginBottom = `${heightPWA}px`
      })
    } else{
      document.body.style.marginBottom = 0
      document.body.classList.remove('bodyMarginBottomPWA')
    }
  }, [isInstalledPwa, isTemporaryPwa])

  return (
    <div className='wrapper-pwa' id="wrapperPwa" style={{ "display": (isInstalledPwa || isTemporaryPwa || isTotem) && "none" }}>
      <div className='container-pwa mdn-Container' >
          <div className='content-pwa' onClick={() => openPopupInstallPWA(prompt)}>
            <span className="mdn-Icon-autoatendimento mdn-Icon--md" data-gtm-event-label="download-pwa"></span>
            <div className='text-pwa-mobile'>
              <span>Adicione o app web do Fatura Fácil na sua tela inicial.</span>
            </div>
            <div className='text-pwa-desktop'>
              <span>Adicione o app web do Fatura Fácil na sua tela inicial.</span>
              <p> Para sua comodidade, baixe o nosso aplicativo web em seu computador e acesse nossos serviços de forma mais rápida.</p>
            </div>
          </div>
          <button className="btn-pwa-close" onClick={() => closeAlertWPA(false)}>
            <i className="mdn-Icon-fechar mdn-Icon--md"></i>
          </button>
      </div>
    </div>
  );
}

export default AlertPWA;
